import { append_to_dom, get_user_info } from "./functions";
import axios from "axios";
import getBrowserFingerprint from "get-browser-fingerprint";
import { fetchAppCheckToken } from "./firebase";

var post_id = $("#post-id").attr("data-post-id");
var rated_recipes = [];
//~ Save old star images into array to use them on mouseLeave
var old_rating_images = [];

var authors_ids = [];

//~ Reset stars to their main src
function reset_stars() {
  for (let i = 0; i < 5; i++) {
    $(`#rating_select_source_${i + 1}`)[0].src = old_rating_images[i];
  }
}

export function rate(rate, id) {
  const rate_url = `${savedSettings.api_url}/ratePost`;

  let rate_body = {
    rate: rate,
    postID: id,
    authorUIDs: authors_ids,
  };

  axios
    .post(rate_url, rate_body, {
      headers: {
        "x-api-key": savedSettings.x_api_key,
        contentType: "application/json; charset=utf-8",
        Authorization: ` Bearer ${
          JSON.parse(localStorage.getItem("login_result"))?.access_token
        }`,
      },
    })
    .then((res) => {
      $("#first_to_rate p").css("display", "none").text("");
      $("#first_to_rate p").css("display", "none").text("");

      $("#your_rating p").text(`تقييمك:  ${parseInt(rate / 2)}`);
      get_user_info(false, false, true);
      $("#rated-tooltip").addClass("is-active");
      setTimeout(() => {
        $("#rated-tooltip").removeClass("is-active");
      }, 3000);
    })
    .catch((err) => {
      // catch_error(err);
      if (err.response.status == 403) {
        rated_by_me();
      }
    });
}

export function rated_by_me() {
  if (JSON.parse(localStorage.getItem("user_info"))?.ratings) {
    rated_recipes = Object.entries(
      JSON.parse(localStorage.getItem("user_info")).ratings
    );
  }

  for (let i in rated_recipes) {
    if (rated_recipes[i][0] == post_id) {
      $("#your_rating p").text(`تقييمك:  ${parseInt(rated_recipes[i][1] / 2)}`);
      $("#first_to_rate p").css("display", "none").text("");

      break;
    }
  }
}

jQuery(document).ready(function ($) {
  if (
    window.location.pathname.includes("/recipe/") &&
    !window.location.pathname.endsWith("recipe/")
  ) {
    if ($("#authors_ids").data("authors-ids")) {
      authors_ids = $("#authors_ids").data("authors-ids") + "";
      authors_ids = authors_ids.split("__");
    }
  }

  for (let i = 0; i < 5; i++) {
    old_rating_images[i] = $(`#rating_select_source_${i + 1}`).attr("src");
  }

  //~ change image on hovering the stars (for UX)
  $("#recipe-rating-list li a img")
    .on("mouseenter", function (e) {
      let this_id = parseInt($(this)[0].id.slice(-1));

      //~ Set current stars to be filled
      $(this)[0].src =
        "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg";

      //~ Set next stars to be empty
      for (let i = this_id + 1; i <= 5; i++) {
        $(`#rating_select_source_${i}`)[0].src =
          "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-large.svg";
      }

      //~ Set prev stars to be filled
      for (let i = this_id - 1; i >= 1; i--) {
        $(`#rating_select_source_${i}`)[0].src =
          "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg";
      }
    })
    .on("mouseleave", function () {});

  //~ Reset Stars on mouseOut of star container
  $("#recipe-rating-list")
    .on("mouseenter", function () {})
    .on("mouseleave", function () {
      reset_stars();
    });

  //~ Fire rating API
  $("#recipe-rating-list li").on("click", function () {
    let selectedRate = parseInt($(this)[0].attributes[0].value) * 2;

    if (!JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
      append_to_dom("popup-login-open", "popup-login", null);

      let pending_rating = {
        post_id: post_id,
        rate: selectedRate,
      };
      localStorage.setItem("pending_rating", true);
      localStorage.setItem(
        "pending_rating_result",
        JSON.stringify(pending_rating)
      );
    } else {
      rate(selectedRate, post_id);
    }
  });

  rated_by_me();
});

export async function public_rate(rate, id) {
  const rate_url = `${savedSettings.api_url}/public/ratePost`;

  const appCheckToken = await fetchAppCheckToken();

  const fingerprint = await getBrowserFingerprint();

  let rate_body = {
    rate: rate,
    postID: id,
  };

  try {
    const res = await axios.post(rate_url, rate_body, {
      headers: {
        contentType: "application/json; charset=utf-8",
        "browser-fingerprint": fingerprint,
        "x-appcheck-token": appCheckToken,
      },
    });

    $("#first_to_rate p").css("display", "none").text("");
    $("#your_rating p").text(`تقييمك:  ${parseInt(rate / 2)}`);

    await get_user_info(false, false, true, false, "", true, fingerprint);

    $("#rated-tooltip").addClass("is-active");
    setTimeout(() => {
      $("#rated-tooltip").removeClass("is-active");
    }, 3000);
  } catch (err) {
    if (err.response?.status === 403) {
      rated_by_me();
    }
  }
}
